import { configureStore } from "@reduxjs/toolkit";
import sureSlice from "./slices/sureSlice";
import ayetSlice from "./slices/ayetSlice";
import authSlice from "./slices/authSlice";
import esmaulHusnaSlice from "./slices/esmaulHusnaSlice";

export default configureStore({
  reducer: {
    sure: sureSlice,
    ayet: ayetSlice,
    auth: authSlice,
    esmaulHusna:esmaulHusnaSlice
  },
});
